var _path, _path2, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLoader(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5732 9.31134C12.9674 9.42438 13.1999 9.83843 13.0348 10.2138C12.6412 11.1088 12.0141 11.8872 11.2134 12.4637C10.2108 13.1854 8.99432 13.5487 7.76009 13.4948C6.52587 13.4409 5.34572 12.973 4.40982 12.1666C3.47392 11.3602 2.83678 10.2622 2.60105 9.04945C2.36532 7.83674 2.54475 6.57999 3.11041 5.48169C3.67606 4.3834 4.59502 3.50753 5.71919 2.99521C6.84336 2.4829 8.10727 2.36398 9.30727 2.65762C10.2657 2.89213 11.1387 3.37889 11.8389 4.06132C12.1325 4.34754 12.0721 4.81852 11.749 5.07099C11.4258 5.32345 10.963 5.25969 10.6554 4.98848C10.1712 4.5616 9.58835 4.25521 8.95431 4.10006C8.07831 3.88571 7.15565 3.97252 6.33501 4.34651C5.51436 4.72049 4.84353 5.35988 4.4306 6.16164C4.01766 6.96339 3.88669 7.88082 4.05877 8.7661C4.23085 9.65137 4.69596 10.4529 5.37917 11.0416C6.06238 11.6303 6.92388 11.9718 7.82487 12.0112C8.72586 12.0505 9.61385 11.7854 10.3458 11.2585C10.8755 10.8771 11.3012 10.3747 11.5902 9.79751C11.7738 9.43083 12.179 9.19831 12.5732 9.31134Z",
    fill: "#858586"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5732 9.31134C12.9674 9.42438 13.1999 9.8384 13.0348 10.2138C12.8448 10.6459 12.5995 11.0528 12.3043 11.4238C11.8547 11.9891 11.2982 12.4602 10.6665 12.8104C10.0347 13.1606 9.34025 13.3829 8.62262 13.4646C8.15153 13.5183 7.67654 13.5107 7.20936 13.4429C6.80355 13.3839 6.57562 12.9674 6.68866 12.5732C6.80169 12.179 7.21362 11.9585 7.62187 11.9972C7.89828 12.0233 8.17732 12.0208 8.45451 11.9892C8.97838 11.9295 9.48536 11.7672 9.94651 11.5116C10.4077 11.256 10.8139 10.912 11.1422 10.4994C11.3158 10.2811 11.4659 10.0458 11.5902 9.79749C11.7737 9.43081 12.179 9.19831 12.5732 9.31134Z",
    fill: "url(#paint0_linear_13135_2011)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_13135_2011",
    x1: 8.75,
    y1: 14.25,
    x2: 12.75,
    y2: 9.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E7E7E7",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E7E7E7"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoader);
export default __webpack_public_path__ + "static/media/loader.2cacaeed.svg";
export { ForwardRef as ReactComponent };